import React, { createContext, useContext, useState, useCallback, ReactNode } from "react";

export interface PageMeta {
  title: string;
  subtitle: string;
  currentPage: number;
  totalPages: number;
  titleTooltip?: string;
  headerContent?: ReactNode;
}

const defaultMeta: PageMeta = {
  title: "",
  subtitle: "",
  currentPage: 1,
  totalPages: 7,
};

interface PageMetaContextValue {
  meta: PageMeta;
  setMeta: (meta: Partial<PageMeta>) => void;
}

const PageMetaContext = createContext<PageMetaContextValue>({
  meta: defaultMeta,
  setMeta: () => {},
});

export const PageMetaProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [meta, setMetaState] = useState<PageMeta>(defaultMeta);

  const setMeta = useCallback((partial: Partial<PageMeta>) => {
    setMetaState((prev) => ({ ...prev, ...partial }));
  }, []);

  return (
    <PageMetaContext.Provider value={{ meta, setMeta }}>
      {children}
    </PageMetaContext.Provider>
  );
};

export const usePageMeta = () => useContext(PageMetaContext);
